import React, { useState, useEffect, useMemo } from "react";

// Function to format the currency
const formatCurrency = (value) => {
  if (value == null || value === 0) return null;
  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

const BidText = ({ data }) => {
  const [displayPrice, setDisplayPrice] = useState("");
  const [displayLabel, setDisplayLabel] = useState("");

  const { propertyDetails, propertyListingDetails, isForeclosureAsset, fcProxyBidEnabled, proxyBidEstimatedOpeningAmt } = data || {};

  // Memoize the label computation to avoid unnecessary recalculations on each render
  const computedLabel = useMemo(() => {
    const { listingType, currentHighestPrice, currentHighestPriceFromDB, startingPrice, listPrice } = propertyListingDetails || {};

    if (propertyDetails?.commonAttributes?.propCategory === "NPL" && propertyListingDetails?.listPrice > 0) {
      return {
        label: "List Price",
        price: formatCurrency(propertyListingDetails.listPrice),
      };
    }

    if (fcProxyBidEnabled) {
      const amount = Number(proxyBidEstimatedOpeningAmt) || 0;
      return {
        label: "Est Opening Bid",
        price: amount ? formatCurrency(amount) : "TBD",
      };
    }

    if ( propertyListingDetails?.listingStatus && propertyListingDetails?.listingStatus?.toUpperCase() !== "CLOSED" ) {
      if (isForeclosureAsset) {
        const estimatedBid = propertyDetails?.detailedAttributes?.estimatedOpeningBid;
        return {
          label: "Est Opening Bid",
          price: estimatedBid !== 0 ? formatCurrency(estimatedBid) : "",
        };
      }

      if (currentHighestPrice || currentHighestPriceFromDB) {
        return {
          label: listingType === "AUCN" ? "Current Highest Bid" : "Current Highest Offer",
          price: formatCurrency(currentHighestPrice || currentHighestPriceFromDB),
        };
      }

      if (startingPrice && listingType === "AUCN") {
        return {
          label: "Starting Bid",
          price: formatCurrency(startingPrice),
        };
      }

      if (listPrice && listingType === "TRNL") {
        return {
          label: "List Price",
          price: formatCurrency(listPrice),
        };
      }
    }

    if (listingType === "AUCN" && !startingPrice && !listPrice) {
      return {
        label: "Under Contract",
        price: "",
      };
    }

    return { label: "", price: "" };
  }, [data, propertyDetails, propertyListingDetails, isForeclosureAsset, fcProxyBidEnabled, proxyBidEstimatedOpeningAmt]);

  useEffect(() => {
    setDisplayLabel(computedLabel.label);
    setDisplayPrice(computedLabel.price);
  }, [computedLabel]);

  return (
    <>
      <h6 className="bid-text">{displayLabel}</h6>
      <h5 className="bid-price">{displayPrice}</h5>
    </>
  );
};

export default BidText;
